import React from "react";
import { useField, ErrorMessage } from "formik";

function TextField({ placeholder, ...props }) {
  const [field] = useField(props);
  return (
    <>
          <div style={{marginBottom:".8rem"}}>
          <input
        type="text"
        id={field.name}
        {...field}
        {...props}
        placeholder={placeholder}
        autoComplete="off"
        className="form_input"
      />
      <ErrorMessage component="div" name={field.name} className="error" />
      </div>
    </>
  );
}

export default TextField;
